module.exports = __webpack_public_path__ + "static/img/imgList.917160a3.png";